import React from 'react';
import background from './assets/menu-sprites.png';

function PokedexMenuSprite({
  currentSpritePosition,
}: {
  currentSpritePosition: undefined | null | number[],
}) {
  if (currentSpritePosition === undefined || currentSpritePosition == null) {
    return (
      <span
        className="-mb-1"
        style={
          {
            width: 40,
            height: 40,
            display: 'inline-block',
          }
        }
      >
        No Pokemon Selected
      </span>
    );
  }
  return (
    <span
      className="-mb-1"
      style={
        {
          width: 40,
          height: 40,
          display: 'inline-block',
          backgroundImage: `url(${background})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: `-${currentSpritePosition[0]}px -${currentSpritePosition[1]}px`,
        }
      }
    />
  );
}

export default PokedexMenuSprite;
